import { Link } from "react-router-dom";
import { Truck, Phone, Mail } from "lucide-react";
import { NAV, BRAND } from "@/lib/data";

const LEGAL_LINKS = [
  { label: "Terms of Service", path: "/terms" },
  { label: "Privacy Policy",   path: "/privacy" },
  { label: "Copyright Policy", path: "/copyright" },
];

const DRIVER_STORY_LINKS = [
  { label: "Driver Testimonials", path: "/testimonials" },
  { label: "How It Works", path: "/how-it-works" },
  { label: "Hear It From The Cab", path: "/#driver-stories" },
  { label: "Blog & Driver Tips", path: "/blog" },
];

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-[#FAFAFA]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid md:grid-cols-5 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-5">
              <span className="w-9 h-9 bg-primary flex items-center justify-center">
                <Truck className="w-5 h-5 text-black" strokeWidth={2} />
              </span>
              <span className="font-head text-lg tracking-[0.25em]">{BRAND.short}</span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              {BRAND.tagline} New trucks, top pay per mile, and flexible home time — all 48 states, coast to coast.
            </p>
          </div>

          <div>
            <p className="font-head text-xs uppercase tracking-[0.3em] text-primary mb-5">Navigate</p>
            <ul className="space-y-3">
              {NAV.filter(n => !["/testimonials", "/how-it-works"].includes(n.path)).map((n) => (
                <li key={n.path}>
                  <Link to={n.path} className="text-white/70 text-sm hover:text-primary transition-colors">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-head text-xs uppercase tracking-[0.3em] text-primary mb-5">Driver Stories</p>
            <ul className="space-y-3">
              {DRIVER_STORY_LINKS.map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-white/70 text-sm hover:text-primary transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-head text-xs uppercase tracking-[0.3em] text-primary mb-5">Legal</p>
            <ul className="space-y-3">
              {LEGAL_LINKS.map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-white/70 text-sm hover:text-primary transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/partners" data-testid="footer-partners-link" className="text-white/70 text-sm hover:text-primary transition-colors">
                  Partner Carriers
                </Link>
              </li>
              <li>
                <Link to="/refund-policy" data-testid="footer-refund-link" className="text-white/70 text-sm hover:text-primary transition-colors">
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-head text-xs uppercase tracking-[0.3em] text-primary mb-5">Get Rolling</p>
            <a href={`tel:${BRAND.phone}`} className="flex items-center gap-3 text-white/70 text-sm hover:text-primary transition-colors mb-3">
              <Phone className="w-4 h-4" /> {BRAND.phone}
            </a>
            <a href={`mailto:${BRAND.email}`} className="flex items-center gap-3 text-white/70 text-sm hover:text-primary transition-colors mb-6">
              <Mail className="w-4 h-4" /> {BRAND.email}
            </a>
            <Link
              to="/apply"
              data-testid="footer-apply-btn"
              className="inline-flex font-head text-sm uppercase tracking-[0.15em] bg-primary text-black px-6 py-3 hover:bg-white transition-colors duration-300"
            >
              Apply Now
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4">
          <p className="text-white/40 text-xs">
            © {new Date().getFullYear()} {BRAND.name}. Andrej Sasaroga DBA Hylas Companion. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            {LEGAL_LINKS.map((l) => (
              <Link key={l.path} to={l.path} className="text-white/30 text-xs hover:text-primary transition-colors">
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
